import type { UnavailableReason } from "./preflight";

/**
 * Console only, and all four reasons — `remoteLog` prints only under `isDevelopment`, and it reports
 * `config`/`error` alone. `warn`, not `error`: Sentry breadcrumbs an `error` over its own event.
 */
export function logClassifierUnavailable(reason: UnavailableReason, detail?: string): void {
  console.warn(`[photo-classifier] unavailable — reason=${reason}${detail ? `: ${detail}` : ""}`);
}
